import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';
import ReactHtmlParser from 'react-html-parser';

import { Wrapper, StyledContainer, Content, ListItem } from './styles';

const Features = ({ data }) => {
  if (!data) return null;
  const { title, titleHtml, subheadingHtml, items } = data;
  return (
    <Wrapper>
      <StyledContainer className="auto-margin">
        {ReactHtmlParser(titleHtml)}
        {ReactHtmlParser(subheadingHtml)}
        <Content className="no-bullets">
          {items.map(({ groupHtml, imageSharp }, index) => {
            return (
              <li
                key={`features-${RichText.asText(title)}-${index.toString()}`}
              >
                <ListItem image={imageSharp.publicURL}>
                  {ReactHtmlParser(groupHtml)}
                </ListItem>
              </li>
            );
          })}
        </Content>
      </StyledContainer>
    </Wrapper>
  );
};

Features.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default Features;
